module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg14.94ee2f4c.jpg";